/**
 * Founder-facing copy for org selection.
 *
 * Held apart from the command so the contracts each string carries are tested
 * as their own unit. On a mechanism whose message IS the behavior, a wording
 * defect is a defect: these strings decide where a founder's private repos land.
 *
 * ASCII punctuation only - the shared register rejects curly quotes and dashes.
 */

/** Exactly one enterprise org was found - announce it, do not ask. */
export function enterpriseSingleNotice(org: string): string {
  return `Using your GitHub Enterprise org ${org} for your workers' brains.`;
}

/** Several enterprise orgs were found - the founder picks among them, not all of their orgs. */
export function enterpriseMultiplePrompt(logins: string[]): string {
  return (
    `You belong to more than one GitHub Enterprise org: ${logins.join(", ")}. ` +
    `Which one should your workers' brains live in?`
  );
}

/**
 * No enterprise linkage was visible.
 *
 * ONE sentence. It does double duty: it is also the only prompt a founder who
 * is a plain member of an enterprise org (whose linkage this check cannot read)
 * ever gets to say "actually, use that one". Keep the benefit mention.
 */
export function noEnterpriseNotice(selectedOrg: string): string {
  return (
    `No GitHub Enterprise org detected; if you have the Microsoft for Startups benefit, ` +
    `your workers' brains can live there - continuing with ${selectedOrg} for now.`
  );
}

/**
 * The check could not run.
 *
 * Says nothing about enterprise orgs in either direction. Not finding an answer
 * is not the same as finding that there is none.
 */
export function undeterminedNotice(): string {
  return `Could not check your GitHub orgs automatically - listing them instead.`;
}

/** The account has no orgs at all, so the App has nowhere to create repos. */
export function noOrgsRefusal(): string {
  return (
    `Your workers' brains are created by a GitHub App, which can only make repositories ` +
    `in an organization, and this account belongs to none. ` +
    `Creating a free GitHub organization and then running \`m8t brain app-create --org <org>\` is enough.`
  );
}
